import React from "react";
import MyNavbar from "./Navbar";
import LoadingBar from "react-redux-loading";
export default function Header() {
  return (
    <>
      <div className="fixed-top">
        <MyNavbar />
      </div>
      <div className="fixed-top">
        <LoadingBar />
      </div>
    </>
  );
}
